module.exports = __webpack_public_path__ + "img/Complejo.c60e9501.svg";